/**
 * How the organization runs its books (ADR-0024). Mirrors the backend `FinanceGovernance` enum.
 *
 * Chosen once, before the parish completes its finance setup, and workspace-wide: a mix of autonomous and
 * governed branches inside one workspace has no coherent consolidated view.
 */
export enum FinanceGovernance {
  /** The default, and today's behaviour: the parish reads every branch's money in full. */
  FullParish = "FULL_PARISH",
  /** Branches own their operational finance; the parish sees health ratios and money remitted to it. */
  BranchAutonomy = "BRANCH_AUTONOMY",
}
